import React, { Component } from 'react';
import Overlay from 'ol/src/Overlay';
// import PropTypes from 'prop-types';

import {
	fetchers,
	cloneObject,
	MapComponent,
	MapWrapper,
	Tooltip,
	SettingsButton as OffCanvasMenuOpener,
	getLayerByName,
	getCoordOfPoint,
} from 'shared';
import { toLonLat, fromLonLat } from 'ol/src/proj';
import { Fill, Icon, Stroke, Style, Text } from 'ol/style';

import updatePOIs from './Markers/updatePOIs';
import updatePositions from './Markers/updatePositions';
import updateStopMarkers from './Markers/updateStopMarkers';
import updateSharingStations from './Markers/updateSharingStations';
import updateTipps from './Markers/updateTipps';
import updateDotMarker from './Markers/updateDotMarker';

import Search from '../Search';
import OffCanvasMenu from '../OffCanvasMenu';
import Subheadline from '../OffCanvasMenu/Subheadline';
import List from '../OffCanvasMenu/List';
import Menu from '../Menu';
import MenuTile from '../Menu/menutile';
import MenuOpener from '../Menu/menuopener';
import CategoryMenu from '../CategoryMenu';

import InfoOverlay from '../InfoOverlay';
import FooterButton from '../InfoOverlay/footerButton';

import MarkerContext from '../../contexts/MarkerContext';

import StopList from '../CategoryList/StopList';
import TippsList from '../CategoryList/TippsList';
import poiMarkerDetails from './MarkerDetails/poiMarkerDetails';
import sharingMarkerDetails from './MarkerDetails/sharingMarkerDetails';
import cityShapeDetails from './MarkerDetails/cityShapeDetails';
import stopMarkerDetails from './MarkerDetails/stopMarkerDetails';
import tipMarkerDetails from './MarkerDetails/tipMarkerDetails';
import parkAndRideDetails from './MarkerDetails/parkAndRideDetails';

import escapeRegExp from '../../utils/escapeRegExp';
import {
	addSharingOperator,
	sharingMappings,
	searchCategories,
	mapConfig,
	sharingTitleMappings,
	colors,
	fonts,
} from '../../utils/config';

import Popup from '../Popup';
import updateParkAndRide from './Markers/updateParkAndRide';

import { positionIcons, positionIconsRT } from './Markers/MarkerSources';
import loadCityShapes from './Geodata/loadCityShapes';
import loadLines from './Geodata/loadLines';

class Map extends Component {
	constructor(props) {
		super(props);

		const pathname = window.location.href
			.replace(new RegExp(`^${escapeRegExp(document.baseURI)}`), '')
			.replace(new RegExp(`${escapeRegExp(window.location.search)}$`), '');
		let position = false;
		let filterType = false;
		let markerId = false;
		let uriParams = [];
		let homeMarker = null;

		const urlParams = new URLSearchParams(window.location.search);

		if (pathname.search('@') > -1) {
			const pathnameParams = pathname.split('@');
			const mapPosition = pathnameParams.pop().split(',');
			if (mapPosition.length === 3) {
				position = {
					lat: parseFloat(mapPosition[0]),
					lng: parseFloat(mapPosition[1]),
					zoom: parseInt(mapPosition[2].replace(/^z/, ''), 10),
				};

				if (urlParams.get('addMarker') === '1') {
					homeMarker = {
						type: 'singlehouse',
						coord: [position.lat, position.lng],
					};
				}
			}

			uriParams = pathnameParams.join('@').split('/');
		} else {
			uriParams = pathname.split('/');
		}

		if (uriParams[0]) {
			filterType = decodeURIComponent(uriParams[0]);
			if (uriParams[1]) {
				markerId = decodeURIComponent(uriParams[1]);
			}
		}

		this.state = {
			map: null,
			tooltip: null,
			useAutofocus: urlParams.get('autofocus') !== '0',
			markerLayer: null,
			filterType,
			markerId,
			position,
			positionSet: false,
			operators: {},
			homeMarker,
			sharingCatMenuItems: [],
			dotMarker: [],
		};

		this.menu = React.createRef();
		this.infooverlay = React.createRef();

		this.filters = {
			stops: {
				Haltestellen: 0, // Alle Haltestellen
				Linien: 0,
				// 'R-Bahn': 0, // 6
				// 'S-Bahn': 0, // 2
				// Stadtbahn: 0, // 1
				// Bus: 0, // 3
				'R-Bahn': 0, // 0
				'S-Bahn': 0, // 1
				Stadtbahn: 0, // 3
				Bus: 0, // 5
			},
			pois: {
				Freizeit: 0,
				'Essen & Trinken': 0,
				Kultur: 0,
				Sehenswürdigkeiten: 0,
				'Rund ums Rad': 0,
				Bildungseinrichtungen: 0,
				'Krankenhäuser & Kliniken': 0,
				'Verbände & Vereine': 0,
			},
			sharing: null,
			// positions: {
			// 	'R-Bahn': 0, // 0
			// 	'S-Bahn': 0, // 1
			// 	Stadtbahn: 0, // 3
			// 	Bus: 0, // 5
			// },
			tipps: {
				Ausflugstipps: 0,
			},
			parkAndRide: {
				'Park & Ride': 0,
			},
			cityticket: {
				StadtTicket: 0,
			},
		};

		this.localStorageSupport = false;

		const { localStorage } = window;
		try {
			const test = 'test';
			localStorage.setItem(test, test);
			localStorage.removeItem(test);

			let filters = localStorage.getItem('mapFilters');
			if (filters !== null) {
				filters = JSON.parse(filters);
				Object.keys(filters).forEach(key => {
					if (Object.prototype.hasOwnProperty.call(this.filters, key)) {
						if (this.filters[key] === null) {
							this.filters[key] = {};
						}
						Object.keys(filters[key]).forEach(category => {
							if (
								key !== 'sharing' &&
								typeof this.filters[key][category] === 'undefined'
							) {
								return;
							}
							if (filters[key][category]) {
								this.filters[key][category] = 2;
								if (key === 'sharing' && category === 'Car2Go') {
									this.filters[key].ShareNow = 2;
								}
							} else {
								this.filters[key][category] = 0;
							}
						});
					}
				});
			}
			this.localStorageSupport = true;
		} catch (e) {
			// do nothing
		}
	}

	// shouldComponentUpdate(nextProps, nextState)
	shouldComponentUpdate() {
		return false;
	}

	componentDidMount() {
		// no clue why this is an extra class but added this as RRP.js does
		document.documentElement.classList.add('prevent-scroll');
		this.loadOperators();
	}

	loadOperators() {
		const { filterType, markerId } = this.state;
		const { setSharingMarkers, marker } = this.context;

		fetchers.fetchSharingOperators().then(operators => {
			Object.keys(operators).forEach(operator => {
				if (['TIER', 'Deer'].indexOf(operator) > -1) {
					/* eslint-disable-next-line no-param-reassign */
					delete operators[operator];
				}
				if (typeof sharingMappings[operator] !== 'undefined') {
					/* eslint-disable-next-line no-param-reassign */
					operators[sharingMappings[operator]] = cloneObject(operators[operator]);
					/* eslint-disable-next-line no-param-reassign */
					delete operators[operator];
				}
			});
			const operatorKeys = Object.keys(operators);
			if (this.filters.sharing === null) {
				this.filters.sharing = {};
			}
			if (operatorKeys.length > 0) {
				const sharingFilters = {};
				operatorKeys.forEach(operator => {
					addSharingOperator(operator);
					if (typeof this.filters.sharing[operator] !== 'undefined') {
						sharingFilters[operator] = this.filters.sharing[operator];
					} else {
						// Default Value for Sharing-Operators:
						sharingFilters[operator] = 0;
					}
				});
				this.filters.sharing = sharingFilters;
				this.setSharingFilters(sharingFilters);
				this.onFilterUpdate('sharing');

				if (this.state.map !== null) {
					const filters = this.getMergedFilters();
					let sharingMarker = marker;
					if (marker !== null && marker.type !== 'sharing') {
						sharingMarker = null;
					}
					updateSharingStations(
						this.state.map,
						operators,
						filters.sharing,
						markers => {
							setSharingMarkers(markers);
						},
						sharingMarker,
						true,
						this.context.openPopup,
						clickedMarker => {
							sharingMarkerDetails(clickedMarker, this.context);
						},
					);
				}
			}

			this.setState({ operators });

			const sharingCatMenuItemsInitial = [
				{
					id: 1,
					icon: 'alle',
					title: 'Alle',
					titlefilter: 'Sharing-Angebote',
					filter: searchCategories.sharing.filter,
					trackData: ['LivKarteSharingAnbieter', 'auswählen', 'Alle'],
				},
			];

			if (typeof searchCategories['sharing-stella'] !== 'undefined') {
				sharingCatMenuItemsInitial.push({
					id: 2,
					icon: 'stella',
					title: 'Stella',
					titlefilter: 'Stella',
					filter: searchCategories['sharing-stella'].filter,
					trackData: ['LivKarteSharingAnbieter', 'auswählen', 'UKatStella'],
				});
			}
			if (typeof searchCategories['sharing-sharenow'] !== 'undefined') {
				sharingCatMenuItemsInitial.push({
					id: 3,
					icon: 'sharenow',
					title: 'ShareNow',
					titlefilter: 'ShareNow',
					filter: searchCategories['sharing-sharenow'].filter,
					trackData: ['LivKarteSharingAnbieter', 'auswählen', 'UKatCar2Go'],
				});
			}
			if (typeof searchCategories['sharing-flinkster'] !== 'undefined') {
				sharingCatMenuItemsInitial.push({
					id: 4,
					icon: 'flinkster',
					title: 'Flinkster',
					titlefilter: 'Flinkster',
					filter: searchCategories['sharing-flinkster'].filter,
					trackData: ['LivKarteSharingAnbieter', 'auswählen', 'UKatFlinkster'],
				});
			}
			if (typeof searchCategories['sharing-stadtmobil'] !== 'undefined') {
				sharingCatMenuItemsInitial.push({
					id: 5,
					icon: 'stadtmobil',
					title: 'Stadtmobil',
					titlefilter: 'Stadtmobil',
					filter: searchCategories['sharing-stadtmobil'].filter,
					trackData: ['LivKarteSharingAnbieter', 'auswählen', 'UKatStadtmobil'],
				});
			}
			if (typeof searchCategories['sharing-regiorad'] !== 'undefined') {
				sharingCatMenuItemsInitial.push({
					id: 6,
					icon: 'regiorad',
					title: 'RegioRad',
					titlefilter: 'RegioRad',
					filter: searchCategories['sharing-regiorad'].filter,
					trackData: ['LivKarteSharingAnbieter', 'auswählen', 'UKatRegioRad'],
				});
			}
			this.setState({ sharingCatMenuItems: sharingCatMenuItemsInitial });

			if (filterType) {
				const newContext = {};
				const catKey = Object.keys(searchCategories).find(
					category => searchCategories[category].filter.filterType === filterType,
				);
				if (catKey) {
					newContext.filters = searchCategories[catKey].filter;

					if (markerId) {
						newContext.marker = {
							id: markerId,
							type: searchCategories[catKey].filter.markerType,
						};
					}

					this.context.setContext(newContext);
				}
				if (this.state.map !== null) {
					this.updateView(this.state.map);
				}
			}
		});
	}

	getMergedFilters() {
		const filters = cloneObject(this.filters);

		if (this.context.filters) {
			Object.keys(filters).forEach(type => {
				if (['filterType', 'markerType'].indexOf(type) > -1 || filters[type] === null) {
					return;
				}
				Object.keys(filters[type]).forEach(category => {
					if (filters[type][category] === 2) {
						filters[type][category] = 0;
					}
				});
			});

			const contextFilters = this.context.filters;
			Object.keys(contextFilters).forEach(type => {
				if (['filterType', 'markerType'].indexOf(type) > -1) {
					filters[type] = contextFilters[type];
					return;
				}
				if (typeof filters[type] === 'undefined') {
					filters[type] = {};
				}
				Object.keys(contextFilters[type]).forEach(category => {
					filters[type][category] = contextFilters[type][category];
				});
			});
		}

		return filters;
	}

	updateFeatureClicked(map, isFeatureClicked) {
		const { setMarker } = this.context;
		if (!isFeatureClicked) {
			setMarker(null);
		}
	}

	// typeFilter = main category the user is currently in
	updateView(map, typeFilter = null) {
		const activeFilters = {};
		const mergedFilters = this.getMergedFilters();
		const {
			marker,
			setStopMarkers,
			setSharingMarkers,
			setPoiMarkers,
			setTipMarkers,
			setParkAndRideMarkers,
			openPopup,
			filters,
			setVehicleMarkers,
			lines,
		} = this.context;

		// marker -> is selected marker, if a map marker is clicked
		if (!marker) {
			document.getElementById('tooltip').style.display = 'none';
			const selectedTooltip = document.getElementById('tooltip-selected');
			// remove inner html to not mess with tooltip ids
			selectedTooltip.innerHTML = '';
			selectedTooltip.style.display = 'none';
		}

		loadLines(null, lines, mergedFilters, map.getView().getZoom());

		this.updateUri(map, mergedFilters, marker);
		Object.keys(mergedFilters).forEach(type => {
			if (['filterType', 'markerType'].indexOf(type) > -1) {
				return;
			}
			if (mergedFilters[type] === null) {
				activeFilters[type] = [];
			} else {
				activeFilters[type] = Object.keys(mergedFilters[type]).filter(
					category => mergedFilters[type][category],
				);
			}
		});

		// close offcanvas menu if not in main filter view
		if (filters !== null) {
			this.closeOffCanvas();
		}

		if (typeFilter === null || typeFilter === 'cityticket') {
			let cityMarker = marker;
			if (marker !== null && marker.type !== 'city') {
				cityMarker = null;
			}
			loadCityShapes(
				false,
				map,
				clickedMarker => {
					cityShapeDetails(clickedMarker, this.context);
				},
				mergedFilters,
				cityMarker,
				filters,
			);
		}

		if (typeFilter === null || typeFilter === 'stops' || typeFilter === 'cityticket') {
			let stopMarker = marker;
			if (marker !== null && marker.type !== 'stop' && marker.type !== 'city') {
				stopMarker = null;
			}
			updateStopMarkers(
				map,
				mergedFilters.stops.Haltestellen,
				markers => {
					setStopMarkers(markers);
				},
				stopMarker,
				clickedMarker => {
					stopMarkerDetails(clickedMarker, this.context, false);
				},
				mergedFilters.cityticket.StadtTicket,
				filters,
				clickedMarkerCityMode => {
					stopMarkerDetails(clickedMarkerCityMode, this.context, true);
				},
			);
		}

		if (typeFilter === null || typeFilter === 'pois') {
			let poiMarker = marker;
			if (marker !== null && marker.type !== 'poi') {
				poiMarker = null;
			}
			updatePOIs(
				map,
				mergedFilters.pois,
				markers => {
					setPoiMarkers(markers);
				},
				poiMarker,
				clickedMarker => {
					poiMarkerDetails(clickedMarker, this.context);
				},
			);
		}

		if (typeFilter === null || typeFilter === 'sharing') {
			if (Object.keys(this.state.operators).length > 0) {
				let sharingMarker = marker;
				if (marker !== null && marker.type !== 'sharing') {
					sharingMarker = null;
				}
				updateSharingStations(
					map,
					this.state.operators,
					mergedFilters.sharing,
					markers => {
						setSharingMarkers(markers);
					},
					sharingMarker,
					false,
					openPopup,
					clickedMarker => {
						sharingMarkerDetails(clickedMarker, this.context);
					},
				);
			}
		}

		if (typeFilter === null || typeFilter === 'stops') {
			updatePositions(map, mergedFilters.stops, markers => {
				setVehicleMarkers(markers);
			});
		}

		if (typeFilter === null || typeFilter === 'tipps') {
			let tipMarker = marker;
			if (marker !== null && marker.type !== 'tip') {
				tipMarker = null;
			}
			updateTipps(
				map,
				mergedFilters.tipps.Ausflugstipps,
				markers => {
					setTipMarkers(markers);
				},
				tipMarker,
				clickedMarker => {
					tipMarkerDetails(clickedMarker, this.context);
				},
			);
		}

		if (typeFilter === null || typeFilter === 'parkAndRide') {
			let prMarker = marker;
			if (marker !== null && marker.type !== 'pr' && marker.type !== 'stop') {
				prMarker = null;
			}
			updateParkAndRide(
				map,
				mergedFilters.parkAndRide['Park & Ride'],
				markers => {
					setParkAndRideMarkers(markers);
				},
				prMarker,
				clickedMarker => {
					parkAndRideDetails(clickedMarker, this.context);
				},
			);
		}

		map.getViewport().setAttribute('data-zoom', map.getView().getZoom());
	}

	updateMap = map => {
		const { positionSet, position, homeMarker, tooltip } = this.state;

		loadCityShapes(
			true,
			map,
			clickedMarker => {
				cityShapeDetails(clickedMarker, this.context);
			},
			null,
		);
		loadLines(map, this.context.lines, null, map.getView().getZoom());

		// adds tooltip div to Map once
		// tooltip div is set in shared
		if (map !== null && tooltip === null) {
			const tooltipRef = document.getElementById('tooltip');
			this.setState({ tooltip: tooltipRef });
			const overlay = new Overlay({
				id: 'tooltip',
				element: tooltipRef,
				offset: [0, 0],
				positioning: 'top-center',
			});
			map.addOverlay(overlay);
			const tooltipSelectedRef = document.getElementById('tooltip-selected');
			const overlaySelected = new Overlay({
				id: 'tooltip-selected',
				element: tooltipSelectedRef,
				offset: [0, 0],
				positioning: 'top-center',
			});
			map.addOverlay(overlaySelected);
		}

		const transportationLayer = getLayerByName(map, 'transportation');
		//
		// Set styles for transportation layer
		//
		transportationLayer.setStyle(feature => {
			let src = '';
			// positionIcons, positionIconsRT
			const transportationIcons = {
				'S-Bahn': 'sbahn',
				Stadtbahn: 'stadtbahn',
				Bus: 'bus',
				'R-Bahn': 'rbahn',
				'SEV-Bus': 'bus',
			};
			if (feature.get('realtime') === 1) {
				src = positionIconsRT[transportationIcons[feature.get('type')]];
			} else {
				src = positionIcons[transportationIcons[feature.get('type')]];
			}
			let text = '';
			const delay = feature.get('delay');
			if (delay && delay !== '') {
				if (delay <= 0) {
					text = '';
				} else {
					text = `+${delay}`;
				}
			}
			let zIndex = 20;
			if (feature.get('hovered')) {
				zIndex = 100;
			}
			return new Style({
				zIndex,
				image: new Icon({
					src,
					size: [42, 60],
					zIndex,
				}),
				text: new Text({
					text,
					font: `400 14px ${fonts.default}`,
					fill: new Fill({
						color: colors.orange,
					}),
					padding: [7, 7, 8, 7],
					backgroundFill: new Fill({
						color: colors.white,
					}),
					offsetX: 32,
					offsetY: -15,
					backgroundStroke: new Stroke({
						color: colors.orange,
						width: 1,
					}),
				}),
			});
		});
		if (positionSet === false && position !== false && homeMarker !== null) {
			this.setState({ homeMarker: null });
			this.centerMarker(homeMarker, map);
		}
		this.setState({ map, positionSet: true });
		this.updateView(map);
	};

	updateUri = (map, filters, marker) => {
		const now = Date.now();
		clearTimeout(this.historyTimeout);
		if (this.lastHistoryUpdate + 300 > now) {
			this.historyTimeout = setTimeout(() => {
				this.updateUri(map, filters, marker);
			}, 300);
			return;
		}

		this.historyUpdateCount = (this.historyUpdateCount || 0) + 1;
		this.lastHistoryUpdate = now;
		let newUri = '';
		if (filters.filterType !== undefined) {
			newUri += encodeURIComponent(filters.filterType);

			if (marker !== null && marker.id) {
				newUri += `/${encodeURIComponent(marker.id)}`;
			}
		}
		const [lon, lat] = toLonLat(map.getView().getCenter());
		newUri += `@${lat.toFixed(5)},${lon.toFixed(5)},z${map.getView().getZoom()}`;

		window.history.replaceState({}, '', newUri);
	};

	onFilterUpdate = (typeFilter = null) => {
		if (this.localStorageSupport) {
			window.localStorage.setItem('mapFilters', JSON.stringify(this.filters));
		}
		this.updateView(this.state.map, typeFilter);
	};

	openOffCanvas = () => {
		this.menu.current.classList.add('opened');
	};

	closeOffCanvas = () => {
		this.menu.current.classList.remove('opened');
	};

	openInfoOverlay = () => {
		this.infooverlay.current.classList.add('opened');
	};

	closeInfoOverlay = () => {
		this.infooverlay.current.classList.remove('opened');
	};

	centerMarker = (marker, usedMap) => {
		const { dotMarker } = this.state;
		let map = usedMap;
		if (map === null || map === undefined) {
			map = this.state.map;
		}
		if (map === null) return;
		// const [markerLayer] = map.getLayersByName('markers');
		let coords;
		if (['stop', 'suburb', 'singlehouse', 'poi', 'street'].indexOf(marker.type) > -1) {
			coords = getCoordOfPoint(marker);
		} else if (marker.type === 'tip') {
			coords = getCoordOfPoint(marker.address);
		}
		if (this.pulsatingMarker) {
			this.pulsatingMarker = [];
		}
		if (dotMarker) {
			this.setState({ dotMarker: [] });
		}
		if (coords) {
			const position = fromLonLat([coords[1], coords[0]]);
			let newZoom = 15;
			if (['stop', 'poi'].indexOf(marker.type) > -1) {
				newZoom = Math.max(
					mapConfig.minZoomLevel[`${marker.type}s`] + mapConfig.minZoom,
					15,
				);
			}
			if (map.getView().getZoom() < newZoom) {
				map.getView().setCenter(position, newZoom);
			} else {
				map.getView().setCenter(position);
			}
			if (['suburb', 'singlehouse', 'street'].indexOf(marker.type) > -1) {
				updateDotMarker(map, marker, markers => {
					this.setState({ dotMarker: markers });
				});
			}
		}
	};

	setCategoryMinZoom = category => {
		const { map, dotMarker } = this.state;
		if (map === null) return;

		if (this.pulsatingMarker) {
			this.pulsatingMarker = [];
		}

		if (dotMarker) {
			this.setState({ dotMarker: [] });
		}

		if (category === null) {
			return;
		}

		const newZoom = mapConfig.minZoomLevel[category.filter.filterType] + mapConfig.minZoom;
		if (map.getView().getZoom() < newZoom) {
			map.getView().setZoom(newZoom);
		}
	};

	setSharingFilters = () => {};

	lastHistoryUpdate = 0;

	render() {
		const {
			marker,
			setMarker,
			setLines,
			setFilters,
			filters,
			stopMarkers,
			sharingMarkers,
			vehicleMarkers,
			poiMarkers,
			tipMarkers,
			popup,
			parkAndRideMarkers,
		} = this.context;
		const { sharingCatMenuItems, dotMarker } = this.state;
		let searchValue = '';
		if (filters !== null) {
			searchValue = searchCategories[filters.filterType].label;
		}

		return (
			<MapWrapper>
				<MapComponent
					updateMap={map => this.updateMap(map)}
					onPositionChanged={map => this.updateView(map)}
					onFeatureClicked={(map, isSelectedMarker) =>
						this.updateFeatureClicked(map, isSelectedMarker)
					}
					transportations={[...vehicleMarkers]}
					markers={[
						...sharingMarkers,
						...parkAndRideMarkers,
						...stopMarkers,
						...poiMarkers,
						...tipMarkers,
						...dotMarker,
					]}
				/>

				<Search
					autoFocus={this.state.useAutofocus && this.state.filterType === false}
					onCategorySelect={this.setCategoryMinZoom}
					onSelect={this.centerMarker}
					value={searchValue}
					categoryMenuVisible={
						(sharingMarkers !== null &&
							filters &&
							typeof filters.sharing !== 'undefined') ||
						(poiMarkers !== null &&
							filters &&
							typeof filters.pois !== 'undefined' &&
							true)
					}
				/>

				{stopMarkers !== null && filters && typeof filters.stops !== 'undefined' && (
					<>
						<StopList
							selectedMarker={marker}
							limit={0}
							items={stopMarkers}
							setMarker={newMarker => {
								setMarker(newMarker);
							}}
							setLines={newLine => {
								setLines(newLine);
							}}
						/>
					</>
				)}

				{sharingMarkers !== null && filters && typeof filters.sharing !== 'undefined' && (
					<>
						<CategoryMenu
							type="sharing"
							activeMenuItem={searchValue || 'Sharing-Angebote'}
							dockedAtSearchbar
							setFilters={setFilters}
							items={sharingCatMenuItems}
						/>
					</>
				)}

				{poiMarkers !== null && filters && typeof filters.pois !== 'undefined' && (
					<>
						<CategoryMenu
							type="places"
							activeMenuItem={searchValue || 'Interessante Orte'}
							dockedAtSearchbar
							setFilters={setFilters}
							items={[
								{
									id: 1,
									icon: 'alle',
									title: 'Alle',
									titlefilter: 'Interessante Orte',
									filter: searchCategories.pois.filter,
									trackData: ['LivKarte', 'Alle', 'InteressanteOrteUntertkat'],
								},
								{
									id: 2,
									icon: 'freizeit',
									title: 'Freizeit',
									titlefilter: 'Freizeit',
									filter: searchCategories['pois-freizeit'].filter,
									trackData: [
										'LivKarte',
										'freizeit',
										'InteressanteOrteUntertkat',
									],
								},
								{
									id: 3,
									icon: 'essentrinken',
									title: 'Essen und Trinken',
									titlefilter: 'Essen & Trinken',
									filter: searchCategories['pois-essentrinken'].filter,
									trackData: [
										'LivKarte',
										'essenundtrinken',
										'InteressanteOrteUntertkat',
									],
								},
								{
									id: 4,
									icon: 'kultur',
									title: 'Kultur',
									titlefilter: 'Kultur',
									filter: searchCategories['pois-kultur'].filter,
									trackData: ['LivKarte', 'kultur', 'InteressanteOrteUntertkat'],
								},
								{
									id: 5,
									icon: 'sehenswuerdigkeiten',
									title: 'Sehens- wertes',
									titlefilter: 'Sehenswürdigkeiten',
									filter: searchCategories['pois-sehenswuerdigkeiten'].filter,
									trackData: [
										'LivKarte',
										'sehenswert',
										'InteressanteOrteUntertkat',
									],
								},
								{
									id: 6,
									icon: 'mehr',
									title: 'Mehr',
									titlefilter: 'Mehr',
									isShowMore: true,
									trackData: ['LivKarte', 'mehr', 'InteressanteOrteUntertkat'],
								},
								{
									id: 7,
									icon: 'rundumsrad',
									title: 'Rund ums Rad',
									titlefilter: 'Rund ums Rad',
									filter: searchCategories['pois-rundumsrad'].filter,
									trackData: [
										'LivKarte',
										'rundumsrad',
										'InteressanteOrteUntertkat',
									],
								},
								{
									id: 8,
									icon: 'bildungseinrichtungen',
									title: 'Bildung',
									titlefilter: 'Bildungseinrichtungen',
									filter: searchCategories['pois-bildungseinrichtungen'].filter,
									trackData: ['LivKarte', 'bildung', 'InteressanteOrteUntertkat'],
								},
								{
									id: 9,
									icon: 'krankenhaeuserkliniken',
									title: 'Kliniken',
									titlefilter: 'Krankenhäuser & Kliniken',
									filter: searchCategories['pois-krankenhaeuserkliniken'].filter,
									trackData: [
										'LivKarte',
										'kliniken',
										'InteressanteOrteUntertkat',
									],
								},
								{
									id: 10,
									icon: 'verbaendevereine',
									title: 'Vereine',
									titlefilter: 'Verbände & Vereine',
									filter: searchCategories['pois-verbaendevereine'].filter,
									trackData: ['LivKarte', 'vereine', 'InteressanteOrteUntertkat'],
								},
							]}
						/>
					</>
				)}

				{tipMarkers !== null && filters && typeof filters.tipps !== 'undefined' && (
					<TippsList
						selectedMarker={marker}
						limit={20}
						items={tipMarkers}
						setMarker={newMarker => {
							setMarker(newMarker);
						}}
						setLines={newLine => {
							setLines(newLine);
						}}
						isButtonVisible
					/>
				)}

				{!filters && (
					<OffCanvasMenuOpener onClick={this.openOffCanvas}>
						<Tooltip type="textonly" anchor="right" title="Sichtbare Elemente" />
					</OffCanvasMenuOpener>
				)}
				<OffCanvasMenu ref={this.menu} onClose={this.closeOffCanvas}>
					<Subheadline>Öffentlicher Nahverkehr</Subheadline>
					<List
						keyPrefix="list-stops"
						items={this.filters.stops}
						onUpdate={stopFilters => {
							this.filters.stops = stopFilters;
							this.onFilterUpdate('stops');
						}}
					/>
					<Subheadline>StadtTicket</Subheadline>
					<List
						keyPrefix="list-city"
						items={this.filters.cityticket}
						onUpdate={cityFilters => {
							this.filters.cityticket = cityFilters;
							this.onFilterUpdate('cityticket');
						}}
					/>

					<Subheadline>Park &amp; Ride</Subheadline>
					<List
						keyPrefix="list-p-r"
						items={this.filters.parkAndRide}
						onUpdate={parkAndRideFilters => {
							this.filters.parkAndRide = parkAndRideFilters;
							this.onFilterUpdate('parkAndRide');
						}}
					/>
					<Subheadline>Sharing-Angebote</Subheadline>
					<List
						keyPrefix="list-sharing"
						items={this.filters.sharing || {}}
						titleMappings={sharingTitleMappings}
						onUpdate={sharingFilters => {
							this.filters.sharing = sharingFilters;
							this.onFilterUpdate('sharing');
						}}
						passSetItems={setItems => {
							this.setSharingFilters = setItems;
						}}
					/>
					<Subheadline>Interessante Orte</Subheadline>
					<List
						keyPrefix="list-pois"
						items={this.filters.pois}
						onUpdate={poiFilters => {
							this.filters.pois = poiFilters;
							this.onFilterUpdate('pois');
						}}
					/>
					<Subheadline>Ausflugstipps</Subheadline>
					<List
						keyPrefix="list-ausflugstipps"
						items={this.filters.tipps}
						onUpdate={tippFilters => {
							this.filters.tipps = tippFilters;
							this.onFilterUpdate('tipps');
						}}
					/>
				</OffCanvasMenu>

				{!filters && (
					<Menu isVisible={!filters}>
						<MenuTile
							title="Öffentlicher Nahverkehr / P+R"
							type="oepnv"
							onClick={() => {
								setFilters(searchCategories.stops.filter);
								this.setCategoryMinZoom(searchCategories.stops);

								if (typeof _paq !== 'undefined') {
									// eslint-disable-next-line no-underscore-dangle
									window._paq.push([
										'trackEvent',
										'LivKarte', // Category
										'nahverkehr', // Action
										'Kategorie', // Name
									]);
								}
							}}
							wideTitle
						/>
						<MenuTile
							title="Sharing-Angebote"
							type="sharing"
							onClick={() => {
								setFilters(searchCategories.sharing.filter);
								this.setCategoryMinZoom(searchCategories.sharing);

								if (typeof _paq !== 'undefined') {
									// eslint-disable-next-line no-underscore-dangle
									window._paq.push([
										'trackEvent',
										'LivKarte', // Category
										'sharingangebote', // Action
										'Kategorie', // Name
									]);
								}
							}}
						/>
						<MenuTile
							title="Interessante Orte"
							type="places"
							onClick={() => {
								setFilters(searchCategories.pois.filter);
								this.setCategoryMinZoom(searchCategories.pois);

								if (typeof _paq !== 'undefined') {
									// eslint-disable-next-line no-underscore-dangle
									window._paq.push([
										'trackEvent',
										'LivKarte', // Category
										'interessanteorte', // Action
										'Kategorie', // Name
									]);
								}
							}}
						/>
						<MenuTile
							title="Ausflugstipps"
							type="tips"
							onClick={() => {
								setFilters(searchCategories.tipps.filter);
								this.setCategoryMinZoom(searchCategories.tipps);

								if (typeof _paq !== 'undefined') {
									// eslint-disable-next-line no-underscore-dangle
									window._paq.push([
										'trackEvent',
										'LivKarte', // Category
										'ausflugstipps', // Action
										'Kategorie', // Name
									]);
								}
							}}
						/>
						<MenuTile
							title="StadtTickets"
							type="cityticket"
							onClick={() => {
								setFilters(searchCategories.cityticket.filter);
								this.setCategoryMinZoom(searchCategories.cityticket);
							}}
						/>
					</Menu>
				)}

				{filters && (
					<MenuOpener
						onClick={() => {
							setFilters(null);

							if (typeof _paq !== 'undefined') {
								// eslint-disable-next-line no-underscore-dangle
								window._paq.push([
									'trackEvent',
									'LivKarte', // Category
									'alle', // Action
									'Kategorie', // Name
								]);
							}
						}}
					/>
				)}

				{popup && <Popup text={popup.text} options={popup.options} />}

				<InfoOverlay ref={this.infooverlay} onClose={this.closeInfoOverlay} />
				<FooterButton onClick={this.openInfoOverlay} />
			</MapWrapper>
		);
	}
}

Map.contextType = MarkerContext;

// Map.propTypes = {};

// Map.defaultProps = {};

export default Map;
